import { CKEDITOR_VALUE, PRISM_VALUE } from './constants';

export const toBoolean = value => {
  if (value === PRISM_VALUE) {
    return true;
  }

  if (value === CKEDITOR_VALUE) {
    return false;
  }

  return null;
};
